import React from 'react';
import {BLOCKS} from "@contentful/rich-text-types";
import {renderRichText} from "gatsby-source-contentful/rich-text";

const options = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <>{children}</>
            )
        },
    },
}

function ListOfPublications(props) {
    return (
        <section key={props.key} className="publications-section">
            <div className="container">
                <div className="row align-items-center pb-3">
                    <div className={`col-12 ${props.content.body ? 'col-md-6' : 'col-md-8'}`}>
                        <h2>{props.content.title}</h2>
                    </div>
                    {props.content.body &&
                        <div className={`col-12 ${props.content.body ? 'col-md-5 offset-md-1' : 'col-md-4'} `}>
                            <div className={'subtitle'}>
                                {renderRichText(props.content.body)}
                            </div>
                        </div>
                    }
                </div>
                <div className="row mt-5">
                    {props.content.elements.map((element, index) => {
                        return(
                            <div key={index} className="col-12 col-md-4 pb-md-5">
                                <a href={element.ctaUrl} className={'text-decoration-none'}>
                                    <div className="blogbox past">
                                        <div className="blogbox--header">
                                            <div className="img-container">
                                                <img src={element.image.url}
                                                     className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                                     alt={element.image.title}/>
                                            </div>
                                        </div>
                                        <div className="blogbox--content">
                                            <span className={'date'}>{element.publishedAt}</span>
                                            <h3>{element.title}</h3>
                                            <div className="blogbox--content__inner">
                                                {element.body && renderRichText(element.body, options)}
                                            </div>
                                            <div className="btn-container">
                                                <div className="more small">
                                                    <i className="fas fa-arrow-right"/>
                                                    {element.ctaText}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
}

export default ListOfPublications;
